import {Service} from "../../../@types/pricingTablePaymentServiceResources.tsx";
import {Trans, useTranslation} from "react-i18next";
import React from "react";
import {buildRateString} from "../../../helpers/pricing/calculatorHelper.ts";
import {HashLink} from "react-router-hash-link";

const MobilePricingTableSection = ({service}: {service: Service}) => {

    const {t} = useTranslation();

    return (
        <>
            <tr className="prices-table-header">
                <td colSpan={5} className="pricing-table-heading-mobile">
                    <HashLink to={`/${t('routes.payment_methods') + '#' + service.heading}`}>
                            <Trans t={t}>
                                {t(service.heading)}
                            </Trans>
                    </HashLink>
                </td>
            </tr>
            {service.countries.map((country, index) => (
                <React.Fragment key={index}>
                    <tr className="prices-table-country text-center">
                        <td colSpan={5}>
                            <div className="d-flex justify-content-center gap-2">
                                {country.flag.map((flag, index) => (
                                        <div key={index} className="d-flex align-items-center">
                                            <img className="me-2" src={flag} alt='country flag icon'/>
                                            <div className="pt-1">{t(country.name[index])}</div>
                                        </div>
                                ))}
                            </div>
                        </td>
                    </tr>
                    <tr className="prices-table-line">
                        <td>
                            <div>
                                <label className="fw-semibold">{t('percentage_rate')}</label>
                                <div>{country.percentageRate} %</div>
                            </div>
                        </td>
                        <td>
                            <div>
                                <label className="fw-semibold">{t('min_rate')}</label>
                                <div>
                                    {buildRateString(country.minRate)}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div>
                                <label className="fw-semibold">{t('max_rate')}</label>
                                <div>
                                    {buildRateString(country.maxRate)}
                                </div>
                            </div>
                        </td>
                        <td className="text-center align-middle fs-4 text-muted">+</td>
                        <td>
                            <div>
                                <label className="fw-semibold">{t('fixed_rate')}</label>
                                <div>{country.fixedRate} &euro;</div>
                            </div>
                        </td>
                    </tr>
                </React.Fragment>
            ))}
        </>
    )
}

export default MobilePricingTableSection;
